// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"79293518","553":"dfa15693"}[chunkId] + ".chunk.js";
};